module.exports = __webpack_public_path__ + "img/18.1d9f49ed.jpg";